import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Encuesta from '../pages/Encuestas/EncuestaVista/Encuesta';  // Importa tu componente de encuesta

const EncuestaRoutes = () => {
    return (
        <Routes>
            {/* Ruta dinámica que captura el token */}
            <Route path=":token" element={<Encuesta />} />
        </Routes>
    );
};

export default EncuestaRoutes;
